import React from 'react'
import clsx from 'clsx'

import Table from '../../../../components/molecules/Table'

import { columnHelper, getIcon } from './helpers'
import { toTitleCase } from '../../../../utilities'
import { usePayment } from '../../../../providers/PaymentProvider'
import useStyles from './styles'

const PaymentSettings = () => {
  const { methods, loaded } = usePayment()

  const classes = useStyles()

  const columns = React.useMemo(() => {
    const brandColumn = columnHelper.accessor('brand', {
      header: 'Brand',
      cell: ({ row }) => {
        const Icon = getIcon(row.original)
        const brand = row.original.brand.split('_').map(toTitleCase).join(' ')
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              minHeight: '49px'
            }}
          >
            <Icon className={classes.icon} />

            <div>{brand}</div>
          </div>
        )
      }
    })

    const nameColumn = columnHelper.accessor('name', {
      header: 'Name',
      cell: ({ row }) => <div>{row.original.name}</div>
    })

    const digitsColumn = columnHelper.accessor('last4', {
      header: 'Last 4 Digits',
      cell: ({ row }) => (
        <div className={classes.right}>****{row.original.last4}</div>
      )
    })

    const expColumn = columnHelper.accessor('exp_month', {
      header: 'Expiration',
      cell: ({ row }) => {
        const { exp_month, exp_year } = row.original
        return (
          <div className={clsx(classes.exp, classes.right)}>
            Exp: {exp_month}/{exp_year}
          </div>
        )
      }
    })

    return [brandColumn, nameColumn, digitsColumn, expColumn]
  }, [classes])

  return (
    <Table
      data={methods}
      columns={columns}
      loaded={loaded}
      message='No payment methods'
      hideCount
      disablePagination
    />
  )
}

export default PaymentSettings
